import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/charging_card_definitions',
  component: Management,
  redirect: '/charging_card_definitions/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/charging_card_definitions/List'),
      redirect: 'list/enabled',
      meta: {
        auth: Auth.common
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/charging_card_definitions/ListTable'),
          meta: {
            auth: Auth.common,
            tabName: 'all'
          }
        },
        {
          path: 'enabled',
          component: () => import('@/views/charging_card_definitions/ListTable'),
          meta: {
            auth: Auth.listCouponDefinitions,
            tabName: 'enabled'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/charging_card_definitions/New'),
      meta: {
        auth: Auth.createChargingCardDefinition
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/charging_card_definitions/Edit'),
      meta: {
        auth: Auth.updateChargingCardDefinition
      }
    },
    // 详情
    {
      path: ':id',
      redirect: ':id/detail',
      component: () => import('@/views/charging_card_definitions/DetailLayout'),
      meta: {
        auth: Auth.showChargingCardDefinition
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/charging_card_definitions/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargingCardDefinition
          }
        },
        // 充电卡
        {
          path: 'charging_cards',
          component: () => import('@/views/charging_card_definitions/details/ChargingCards'),
          meta: {
            tabName: 'charging_cards', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargingCardDefinition
          }
        },
        // 消费记录
        {
          path: 'consumption_records',
          component: () => import('@/views/charging_card_definitions/details/ConsumptionRecords'),
          meta: {
            tabName: 'consumption_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargingCardDefinition
          }
        }
      ]
    }
  ]
}
